module.exports = __webpack_public_path__ + "img/ic_settings_20.0d5e093a.svg";